<template>
  <div class="camera-component">
    <canvas ref="canvas" style="display: none"></canvas>

    <div v-if="!photoTaken">
      <video ref="video" autoplay playsinline></video>

      <button class="btn-modern btn-modern-add btn-block" @click="takePhoto">
        TIRAR FOTO
      </button>

      <button
        v-if="videoDevices.length > 1"
        class="btn-modern btn-modern-info btn-block"
        @click="switchCamera"
      >
        ALTERNAR CÂMERA
      </button>
    </div>

    <div v-else>
      <img :src="photoData" alt="Foto capturada" />

      <button class="btn-modern btn-modern-add btn-block" @click="retakePhoto">
        TIRAR OUTRA FOTO
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "Photo",

  data() {
    return {
      photoTaken: false,
      photoData: null,
      stream: null,
      videoDevices: [],
      currentDeviceIndex: 0,
    };
  },

  async mounted() {
    await this.getVideoDevices();
    await this.startCamera();
  },

  methods: {
    async getVideoDevices() {
      const devices = await navigator.mediaDevices.enumerateDevices();
      this.videoDevices = devices.filter(
        (device) => device.kind === "videoinput"
      );

      // Se tiver mais de uma, tenta começar pela traseira
      const backCamera = this.videoDevices.find(
        (device) =>
          device.label.toLowerCase().includes("back") ||
          device.label.toLowerCase().includes("traseira")
      );

      if (backCamera) {
        this.currentDeviceIndex = this.videoDevices.indexOf(backCamera);
      }
    },

    async startCamera() {
      if (this.stream) this.stopCamera();

      try {
        const deviceId = this.videoDevices[this.currentDeviceIndex]?.deviceId;

        this.stream = await navigator.mediaDevices.getUserMedia({
          video: deviceId
            ? { deviceId: { exact: deviceId } }
            : { facingMode: "environment" },
        });

        this.$refs.video.srcObject = this.stream;
      } catch (error) {
        console.error("Erro ao acessar câmera:", error);
      }
    },

    async switchCamera() {
      this.currentDeviceIndex =
        (this.currentDeviceIndex + 1) % this.videoDevices.length;

      await this.startCamera();
    },

    takePhoto() {
      const video = this.$refs.video;
      const canvas = this.$refs.canvas;
      const context = canvas.getContext("2d");

      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      context.drawImage(video, 0, 0);

      this.photoData = canvas.toDataURL("image/jpeg", 0.9);
      this.photoTaken = true;

      const photoFile = this.dataURLtoFile(this.photoData, "photo.jpg");
      this.$emit("photo-taken", photoFile);

      this.stopCamera();
    },

    dataURLtoFile(dataurl, filename) {
      const arr = dataurl.split(",");
      const mime = arr[0].match(/:(.*?);/)[1];
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }

      return new File([u8arr], filename, { type: mime });
    },

    async retakePhoto() {
      this.photoTaken = false;
      this.photoData = null;
      await this.startCamera();
    },

    stopCamera() {
      if (this.stream) {
        this.stream.getTracks().forEach((track) => track.stop());
      }
    },
  },

  beforeDestroy() {
    this.stopCamera();
  },
};
</script>

<style scoped>
video {
  width: 100%;
  max-width: 500px;
}

img {
  width: 100%;
  max-width: 500px;
}
</style>